/**
 * 字段显示过滤器
 * @param {string} value 字段值
 * @param {string} placeholder 占位符
 */
export function echoFieldFilter(value, placeholder = '--') {
  if (value || value === 0) return value;
  return placeholder;
}



// WEBPACK FOOTER //
// ./src/filters/index.js